module.exports = __webpack_public_path__ + "static/media/distancing.981eca4c.png";